import { MutationType } from '@tencent/slide-sdk-pb-model';
import type { TargetType } from '@tencent/slide-sdk-pb-model';
import type { WithExtensions } from '../data';
import type { IValidSetDataExtensionMutationData } from '../mutation/base';

export function getDataExtensionKeyframe(
    targetType: TargetType,
    data: WithExtensions<string> & { id: string },
    pageId?: string,
    targetId?: string,
) {
    if (!data.extensions) {
        return [];
    }

    const muts: IValidSetDataExtensionMutationData[] = [];
    for (const [key, value] of Object.entries(data.extensions)) {
        if (typeof value !== 'string') {
            continue;
        }

        const setDataExtension: IValidSetDataExtensionMutationData = {
            type: MutationType.SetDataExtension,
            targetType,
            pageId,
            targetId,
            key,
            value,
        };
        muts.push(setDataExtension);
    }

    return muts;
}
